export default {
	heading: 'Recent sold prices',
};
